<template>
  <div class="ly-inner">
    <table-data ref="refTable"
      :loginUserId="loginUserId"
      @visibleApprove="visibleApprove" />
    <idc-modal
      :visible.sync="isOpitionContent"
      :title="$t('messages.titApprovalOpinion')"
    >
      <template #content>
        <!-- 22.03.14 다국어 처리 -->
        <p class="opiton">{{ opitionContent }}</p>
      </template>
    </idc-modal>

    <idc-modal :visible.sync="isApprove" :title="$t('messages.approveComplete')">
      <template #content>
        <el-row>
          <el-col :span="24">
            <idc-input
              v-model="sbst"
              size="medium"
              :placeholder="$t('messages.plProcessOpiton')"
            />
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer half">
          <el-button size="large" type="primary" @click="handleClickApprove">{{
            $t("messages.btnConfirm")
          }}</el-button>
          <el-button size="large" type="info" @click="isApprove = false;">{{
            $t("messages.btnCancel")
          }}</el-button>
        </div>
      </template>
    </idc-modal>
  </div>
</template>

<script>
import TableData from "@/components/approve/TableData";
import IdcModal from "@/components/common/IdcModal";
import IdcInput from "@/components/common/IdcInput";
export default {
  components: {
    TableData,
    IdcModal,
    IdcInput,
  },
  data() {
    return {
      loginUserId: '',
      isApprove: false,
      approveList: [
        { label: "선택", value: -1 },
        { label: "승인", value: 0 },
        // { label: "보류", value: 1 },
        { label: "반려", value: 2 },
      ],
      selectedApprove: -1,

      isOpitionContent: false,
      opitionContent: '',

      // 
      exeWflowScndApvId: '',
      exeWflowId: '',
      stepCd: '',
      ticktId: '',
      sbst: '',
    };
  },
  created() {
    this.$EventBus.$on("isOpition", (data) => {
      this.opitionContent = data;
      this.isOpitionContent = true;
    });
  },
  mounted() {
    this.$nextTick(async () => {
      // TODO 로그인 아이디가 없음... 
      this.loginUserId = await this.$store.getters['userInfoStore/getLoginUserId'];
    });
  },
  methods: {
    visibleApprove(data) {
      this.exeWflowScndApvId = data.exeWflowScndApvId;
      this.exeWflowId = data.exeWflowId;
      this.stepCd = data.stepCd;
      this.ticktId = data.ticktId;

      this.isApprove = true;
    },
    handleClickApprove() {
      if (!confirm("승인하시겠습니까?")) return;
      const data = {
        exeWflowScndApvId: this.exeWflowScndApvId,
        apvOpin: this.sbst,
        ticktId: this.ticktId,
      };
      this.$BIZ_SERVICE.post(this.$API_URLS.Svc.putWflowScndAprTickt, data)
        .then(res => {
          alert('승인하였습니다.');
        })
        .catch((error) => {
          alert(error);
        })
        .finally(() => { 
          this.isApprove = false;
          this.$refs.refTable.getApproveList();
        });

      /*
      switch (this.selectedApprove) {
        case 0:
          this.$store.dispatch("wflowStore/postApproval", {
            exeWflowId: this.exeWflowId,
            stepCd: this.stepCd,
            ticktId: this.ticktId,
            sbst: this.sbst,
          }).then(res => {
            this.afterApprove();
          });
          break;
        case 1:
          this.$store.dispatch("wflowStore/postApvHld", {
            exeWflowId: this.exeWflowId,
            stepCd: this.stepCd,
            ticktId: this.ticktId,
            sbst: this.sbst,
          }).then(res => {
            this.afterApprove();
          });
          break;
        case 2:
          this.$store.dispatch("wflowStore/postApvRcess", {
            exeWflowId: this.exeWflowId,
            stepCd: this.stepCd,
            ticktId: this.ticktId,
            sbst: this.sbst,
          }).then(res => {
            this.afterApprove();
          });
          break;
        default:
          alert("승인 처리를 선택해 주세요.")
          break;
      }
      */
    },
    afterApprove() {
      this.$refs.refTable.getApproveList();
      this.isApprove = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.opiton {
  text-align: left;
  color: $--color-black;
}
.info {
  text-align: left;
  color: $--color-black;
}
::v-deep {
  .el-dialog__wrapper {
    .el-row {
      padding: {
        top: 20px;
        bottom: 0;
      }
      margin-bottom: -10px;
    }
    .el-col {
      .el-select {
        width: 100%;
      }
      &:not(:first-child) {
        padding-top: 15px;
      }
    }
  }
}
</style>
